import React from "react";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const ResidencesGallery = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <div>
        <AnimateOnScroll animationType="slideup">
          <h1>{t("gallery_residence_title")}</h1>
        </AnimateOnScroll>
      </div>
    </ImageLoader>
  );
};

export default ResidencesGallery;
